import { Component, Inject, OnInit } from "@angular/core";
// import Swiper core and required modules
import SwiperCore, {
  FreeMode,
  Navigation,
  Thumbs,
  SwiperOptions,
} from "swiper";
import Swiper from "swiper";
import { IProductForShop } from "src/app/Models/Interface/Shop/Product/product-for-shop";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormBuilder } from "@angular/forms";
import { environment } from "src/environments/environment";
import { UserDetailsService } from "../../Services/user-details.service";

// install Swiper modules
Swiper.use([FreeMode, Navigation, Thumbs]);

@Component({
  selector: "app-product-details",
  templateUrl: "./product-details.component.html",
  styleUrls: ["./product-details.component.scss"],
})
export class ProductDetailsComponent implements OnInit {
  thumbsSwiper: any;
  productDetail = {} as any;
  imageEndPoint = environment.imgSrc;

  constructor(
    public dialogRef: MatDialogRef<ProductDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public userDetailsService: UserDetailsService
  ) {}

  ngOnInit(): void {
    this.productDetail = this.data.product;
    console.log(this.data);
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
